export const hasProperty = <T extends object, K extends PropertyKey>(
  obj: T | unknown,
  prop: K
): obj is T & Record<K, unknown> => typeof obj === 'object' && obj !== null && prop in obj;

type PropOfObj<T, U extends PropertyKey> = U extends keyof T ? T[U] : unknown;
export const getProperty = <T, K extends PropertyKey>(obj: T, prop: K) =>
  (hasProperty(obj, prop) ? obj[prop] : undefined) as PropOfObj<T, K>;
